import React, { createContext, useState, useContext, useEffect } from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [username, setUsername] = useState('');
  const [role, setRole] = useState('');
  const [loading, setLoading] = useState(true);

  // Check if user is already logged in on app load
  useEffect(() => {
    const storedAuth = localStorage.getItem('adminAuth');
    const storedUsername = localStorage.getItem('adminUsername');
    const storedRole = localStorage.getItem('adminRole');
    if (storedAuth === 'true') {
      setIsAuthenticated(true);
      setUsername(storedUsername || '');
      setRole(storedRole || '');
    }
    setLoading(false);
  }, []);

  const login = (user, pass) => {
    // Admin credentials
    const ADMIN_USERNAME = 'admin';
    const ADMIN_PASSWORD = 'admin123';

    // Superadmin credentials
    const SUPERADMIN_USERNAME = 'superadmin';
    const SUPERADMIN_PASSWORD = 'super123';

    if (user === ADMIN_USERNAME && pass === ADMIN_PASSWORD) {
      setIsAuthenticated(true);
      setUsername(user);
      setRole('admin');
      localStorage.setItem('adminAuth', 'true');
      localStorage.setItem('adminUsername', user);
      localStorage.setItem('adminRole', 'admin');
      return { success: true, message: 'Login successful!', role: 'admin' };
    } else if (user === SUPERADMIN_USERNAME && pass === SUPERADMIN_PASSWORD) {
      setIsAuthenticated(true);
      setUsername(user);
      setRole('superadmin');
      localStorage.setItem('adminAuth', 'true');
      localStorage.setItem('adminUsername', user);
      localStorage.setItem('adminRole', 'superadmin');
      return { success: true, message: 'Login successful!', role: 'superadmin' };
    }
    return { success: false, message: 'Invalid username or password' };
  };

  const logout = () => {
    setIsAuthenticated(false);
    setUsername('');
    setRole('');
    localStorage.removeItem('adminAuth');
    localStorage.removeItem('adminUsername');
    localStorage.removeItem('adminRole');
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, username, role, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};
